// Centralised services data — used by Services grid, Services page, and Service detail pages.

export const SERVICES = [
  {
    slug: "building-materials",
    n: "01",
    title: "Building Materials",
    short:
      "Cement, steel, finishes, fixtures and aggregates — sourced from accredited mills and distributors.",
    long:
      "From foundation to finish, One Sphere supplies project-grade building materials for developers, contractors and consultants. We work directly with accredited mills and certified distributors so every shipment is documented, traceable and compliant with regional standards. Whether you need a single trial order or a multi-tower programme, we scale to the brief without quality drift.",
    img: "https://images.unsplash.com/photo-1602128110234-2d11c0aaadfe?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwzfHxtaW5pbWFsaXN0JTIwYXJjaGl0ZWN0dXJlfGVufDB8fHx8MTc3OTAxMjQ3Mnww&ixlib=rb-4.1.0&q=85",
    features: [
      "Cement, aggregates, ready-mix",
      "Steel rebar, structural sections, fixings",
      "Tiles, surfaces, sanitary ware, fittings",
      "Itemised pricing with mill certificates",
    ],
  },
  {
    slug: "interior-fitout-supplies",
    n: "02",
    title: "Interior Fit-out Supplies",
    short:
      "Joinery, surfaces, lighting, hardware and bespoke finishes for luxury and commercial projects.",
    long:
      "We curate the materials that define great interiors — bespoke joinery, premium surfaces, architectural lighting and the hardware that holds it all together. Our category leads work alongside architects and design studios so specifications are matched to budget without compromising on the look or feel that the brief demands.",
    img: "https://images.unsplash.com/photo-1618221195710-dd6b41faaea6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBpbnRlcmlvciUyMGRlc2lnbnxlbnwwfHx8fDE3NzkwMTI0NzJ8MA&ixlib=rb-4.1.0&q=85",
    features: [
      "Custom joinery and millwork",
      "Stone, timber, decorative laminates",
      "Architectural and decorative lighting",
      "Furniture, hardware and accessories",
    ],
  },
  {
    slug: "rider-equipment",
    n: "03",
    title: "Rider Equipment",
    short:
      "Helmets, jackets, protective gear, accessories and fleet outfitting for delivery and lifestyle riders.",
    long:
      "Whether outfitting a delivery fleet or supplying lifestyle riders, we source certified protective gear and accessories at scale. From entry-level fleet kits to premium lifestyle equipment, every product we supply meets recognised safety standards and is backed by warranty.",
    img: "https://images.unsplash.com/photo-1611004061856-ccc3cbe944b2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwyfHxtb3RvcmN5Y2xlJTIwcmlkZXIlMjBoZWxtZXR8ZW58MHx8fHwxNzc5MDEyNDg2fDA&ixlib=rb-4.1.0&q=85",
    features: [
      "Certified helmets and protective gear",
      "Jackets, gloves, boots, accessories",
      "Branded fleet outfitting at scale",
      "After-sales support and replacements",
    ],
  },
  {
    slug: "marketing-gifts-events",
    n: "04",
    title: "Marketing Gifts & Events",
    short:
      "Curated corporate gifting, branded merchandise and end-to-end event management for premium brands.",
    long:
      "Memorable brand moments start with thoughtful execution. We design, source and deliver corporate gifting programmes, branded merchandise and turnkey events — from intimate launches to large-scale conferences — with the kind of polish that reflects well on you, not us.",
    img: "https://images.unsplash.com/photo-1605174697130-0bb0b83c92fc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBjb3Jwb3JhdGUlMjBnaWZ0c3xlbnwwfHx8fDE3NzkwMTI0ODZ8MA&ixlib=rb-4.1.0&q=85",
    features: [
      "Bespoke corporate gifting programmes",
      "Branded merchandise and apparel",
      "End-to-end event production",
      "Curated supplier and venue network",
    ],
  },
  {
    slug: "gym-fitness-equipment",
    n: "05",
    title: "Gym & Fitness Equipment",
    short:
      "Commercial-grade strength, cardio and wellness equipment for hotels, residences and studios.",
    long:
      "From boutique residential gyms to full hotel fitness floors, we supply commercial-grade strength, cardio and wellness equipment from the brands trusted by global operators — with installation, servicing and parts handled by a single point of contact.",
    img: "https://images.unsplash.com/photo-1540497077202-7c8a3999166f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBneW0lMjBlcXVpcG1lbnR8ZW58MHx8fHwxNzc5MDEyNDg2fDA&ixlib=rb-4.1.0&q=85",
    features: [
      "Strength, cardio, functional equipment",
      "Recovery, wellness, mind-body fitouts",
      "Installation and on-site servicing",
      "Spare parts and lifecycle support",
    ],
  },
  {
    slug: "hvac-spare-parts",
    n: "06",
    title: "HVAC Spare Parts",
    short:
      "Compressors, coils, controls, filtration and OEM-grade spares for industrial and commercial HVAC systems.",
    long:
      "Downtime is expensive. We hold and source OEM-grade HVAC spares — compressors, coils, controls, filtration and consumables — for industrial and commercial systems, with expedited logistics for critical-priority requests.",
    img: "https://images.pexels.com/photos/3637943/pexels-photo-3637943.jpeg",
    features: [
      "Compressors, motors, fans, coils",
      "Controls, sensors, BMS components",
      "Filtration and refrigerant consumables",
      "Critical-priority logistics available",
    ],
  },
  {
    slug: "erp-software-apps",
    n: "07",
    title: "ERP Software & Apps",
    short:
      "Custom ERP, mobile and web application development — scoped, built and maintained by senior engineers.",
    long:
      "Our in-house engineering team builds custom ERP, mobile and web applications for operators who have outgrown off-the-shelf tools. Every engagement is scoped, designed and shipped with senior engineers — not handed to a junior team — and supported with ongoing maintenance.",
    img: "https://images.unsplash.com/photo-1573164713988-8665fc963095?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHw0fHxjb3Jwb3JhdGUlMjBidXNpbmVzcyUyMHRlY2hub2xvZ3l8ZW58MHx8fHwxNzc5MDEyNDczfDA&ixlib=rb-4.1.0&q=85",
    features: [
      "Custom ERP — finance, ops, inventory",
      "Mobile (iOS / Android) and web apps",
      "Cloud architecture and DevOps",
      "Ongoing maintenance and SLAs",
    ],
  },
  {
    slug: "computer-systems-software",
    n: "08",
    title: "Computer Systems & Software",
    short:
      "Workstations, networking, licenses and managed software supply for offices, studios and enterprises.",
    long:
      "We supply and licence the systems modern businesses run on — workstations, networking, productivity and design software — with managed procurement so your IT team focuses on operations, not purchase orders.",
    img: "https://images.unsplash.com/photo-1579389083046-e3df9c2b3325?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwzfHxjb3Jwb3JhdGUlMjBidXNpbmVzcyUyMHRlY2hub2xvZ3l8ZW58MHx8fHwxNzc5MDEyNDczfDA&ixlib=rb-4.1.0&q=85",
    features: [
      "Workstations, laptops, peripherals",
      "Networking, security, infrastructure",
      "Productivity, design and CAD licensing",
      "Managed procurement and renewals",
    ],
  },
  {
    slug: "commercial-brokerage",
    n: "09",
    title: "Commercial Brokerage",
    short:
      "Strategic intermediation for property, supply contracts and cross-border B2B trade across the region.",
    long:
      "Where deals are complex, we add value as a discreet intermediary — property, supply contracts, cross-border B2B trade — using established relationships, regulatory know-how and disciplined process to move transactions from intent to close.",
    img: "https://images.unsplash.com/photo-1541746972996-4e0b0f43e02a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwyfHxjb3Jwb3JhdGUlMjBidXNpbmVzcyUyMHRlY2hub2xvZ3l8ZW58MHx8fHwxNzc5MDEyNDczfDA&ixlib=rb-4.1.0&q=85",
    features: [
      "Commercial property brokerage",
      "Supply contracts and tenders",
      "Cross-border trade facilitation",
      "Discreet, relationship-led process",
    ],
  },
];

export const getServiceBySlug = (slug) => SERVICES.find((s) => s.slug === slug);
export const getNeighbourServices = (slug) => {
  const i = SERVICES.findIndex((s) => s.slug === slug);
  const prev = SERVICES[(i - 1 + SERVICES.length) % SERVICES.length];
  const next = SERVICES[(i + 1) % SERVICES.length];
  return { prev, next };
};
